"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFaqListDto = instanceOfFaqListDto;
exports.FaqListDtoFromJSON = FaqListDtoFromJSON;
exports.FaqListDtoFromJSONTyped = FaqListDtoFromJSONTyped;
exports.FaqListDtoToJSON = FaqListDtoToJSON;
exports.FaqListDtoToJSONTyped = FaqListDtoToJSONTyped;
var FaqItemDto_1 = require("./FaqItemDto");
/**
 * Check if a given object implements the FaqListDto interface.
 */
function instanceOfFaqListDto(value) {
    if (!('items' in value) || value['items'] === undefined)
        return false;
    if (!('language' in value) || value['language'] === undefined)
        return false;
    return true;
}
function FaqListDtoFromJSON(json) {
    return FaqListDtoFromJSONTyped(json, false);
}
function FaqListDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'items': (json['items'].map(FaqItemDto_1.FaqItemDtoFromJSON)),
        'language': json['language'],
    };
}
function FaqListDtoToJSON(json) {
    return FaqListDtoToJSONTyped(json, false);
}
function FaqListDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'items': (value['items'].map(FaqItemDto_1.FaqItemDtoToJSON)),
        'language': value['language'],
    };
}
